import { render, staticRenderFns } from "./vertifyMoblie.vue?vue&type=template&id=5dfde73f&scoped=true&"
import script from "./vertifyMoblie.vue?vue&type=script&lang=js&"
export * from "./vertifyMoblie.vue?vue&type=script&lang=js&"
import style0 from "./vertifyMoblie.vue?vue&type=style&index=0&id=5dfde73f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfde73f",
  null
  
)

export default component.exports